// import React, {
//   createContext,
//   useContext,
//   useState,
//   useEffect,
//   useCallback,
//   useRef,
// } from "react";
// import axios from "axios";

// const CartContext = createContext();

// export const useCart = () => {
//   const context = useContext(CartContext);
//   if (!context) {
//     throw new Error("useCart must be used within a CartProvider");
//   }
//   return context;
// };

// export const CartProvider = ({ children }) => {
//   const [cartCount, setCartCount] = useState(0);
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [lastFetchTime, setLastFetchTime] = useState(0);

//   const CACHE_DURATION = 30000;
//   const abortControllerRef = useRef(null);

//   const getUserData = useCallback(() => {
//     const userData = localStorage.getItem("pm-user-data");
//     return userData ? JSON.parse(userData) : null;
//   }, []);

//   const isUserLoggedIn = useCallback(() => {
//     return !!localStorage.getItem("pm-user-data");
//   }, []);

//   const fetchCartData = useCallback(
//     async (forceRefresh = false) => {
//       if (!isUserLoggedIn()) {
//         setCartCount(0);
//         setCartItems([]);
//         return { items: [], count: 0 };
//       }

//       const now = Date.now();
//       const shouldUseCache =
//         !forceRefresh && now - lastFetchTime < CACHE_DURATION;

//       if (shouldUseCache && cartItems.length > 0) {
//         return { items: cartItems, count: cartCount };
//       }

//       if (abortControllerRef.current) {
//         abortControllerRef.current.abort();
//       }

//       abortControllerRef.current = new AbortController();

//       try {
//         setLoading(true);
//         const user = getUserData();

//         const response = await axios.get(
//           `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${user._id}`,
//           {
//             signal: abortControllerRef.current.signal,
//             timeout: 5000,
//           }
//         );

//         const items = response.data.items || [];
//         const transformedItems = items.map((item) => ({
//           id: item._id,
//           name: item.product?.name,
//           price: item.product.price,
//           quantity: item.quantity,
//           image: item.product.images[0],
//           productId: item.product._id,
//           gstPercentage: item.product.gstPercentage || 0,
//           extraTaxPercentage: item.product.extraTaxPercentage || 0,
//           shippingCharge: item.product.shippingCharge || 0,
//         }));

//         setCartItems(transformedItems);
//         setCartCount(items.length);
//         setLastFetchTime(now);

//         return { items: transformedItems, count: items.length };
//       } catch (error) {
//         if (error.name === "AbortError") {
//           console.log("Request was aborted");
//           return { items: cartItems, count: cartCount };
//         }

//         console.error("Error fetching cart data:", error);
//         setCartCount(0);
//         setCartItems([]);
//         return { items: [], count: 0 };
//       } finally {
//         setLoading(false);
//         abortControllerRef.current = null;
//       }
//     },
//     [isUserLoggedIn, getUserData, cartItems, cartCount, lastFetchTime]
//   );

//   const fetchCartCount = useCallback(async () => {
//     if (!isUserLoggedIn()) {
//       setCartCount(0);
//       return;
//     }

//     try {
//       const user = getUserData();
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/cart/get-users-cart/${user._id}`,
//         {
//           timeout: 3000,
//           params: { countOnly: true },
//         }
//       );

//       const count = response.data.items?.length || 0;
//       setCartCount(count);
//       setLastFetchTime(Date.now());
//     } catch (error) {
//       console.error("Error fetching cart count:", error);
//       setCartCount(0);
//     }
//   }, [isUserLoggedIn, getUserData]);

//   // New method to update cart count directly
//   const updateCartCount = useCallback((newCount) => {
//     setCartCount(newCount);
//   }, []);

//   const updateCartOptimistically = useCallback((productId, quantity) => {
//     setCartItems((prevItems) =>
//       prevItems.map((item) =>
//         item.productId === productId ? { ...item, quantity } : item
//       )
//     );
//   }, []);

//   const removeFromCartOptimistically = useCallback((productId) => {
//     setCartItems((prevItems) =>
//       prevItems.filter((item) => item.productId !== productId)
//     );
//     setCartCount((prevCount) => Math.max(0, prevCount - 1));
//   }, []);

//   const addToCartOptimistically = useCallback((newItem) => {
//     setCartItems((prevItems) => [...prevItems, newItem]);
//     setCartCount((prevCount) => prevCount + 1);
//   }, []);

//   const incrementCartCount = useCallback(() => {
//     setCartCount((prevCount) => prevCount + 1);
//   }, []);

//   const decrementCartCount = useCallback(() => {
//     setCartCount((prevCount) => Math.max(0, prevCount - 1));
//   }, []);

//   const resetCartCount = useCallback(() => {
//     setCartCount(0);
//     setCartItems([]);
//     setLastFetchTime(0);
//   }, []);

//   // New method to refresh cart data after adding/removing items
//   const refreshCart = useCallback(async () => {
//     await fetchCartData(true);
//   }, [fetchCartData]);

//   // Method to add item to cart and refresh count
//   const addToCart = useCallback(
//     async (productId, quantity = 1) => {
//       if (!isUserLoggedIn()) {
//         return { success: false, message: "User not logged in" };
//       }

//       try {
//         const user = getUserData();
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
//           {
//             userId: user._id,
//             productId: productId,
//             quantity: quantity,
//           },
//           {
//             headers: { "Content-Type": "application/json" },
//           }
//         );

//         // Update cart count after successful addition
//         await fetchCartCount();

//         return { success: true, data: response.data };
//       } catch (error) {
//         console.error("Error adding to cart:", error);
//         return { success: false, error };
//       }
//     },
//     [isUserLoggedIn, getUserData, fetchCartCount]
//   );

//   // Method to remove item from cart and refresh count
//   const removeFromCart = useCallback(
//     async (productId) => {
//       if (!isUserLoggedIn()) {
//         return { success: false, message: "User not logged in" };
//       }

//       try {
//         const user = getUserData();
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/cart/remove-product-from-cart`,
//           {
//             userId: user._id,
//             productId: productId,
//           },
//           {
//             headers: { "Content-Type": "application/json" },
//           }
//         );

//         // Update cart count after successful removal
//         await fetchCartCount();

//         return { success: true, data: response.data };
//       } catch (error) {
//         console.error("Error removing from cart:", error);
//         return { success: false, error };
//       }
//     },
//     [isUserLoggedIn, getUserData, fetchCartCount]
//   );

//   // Method to update item quantity in cart
//   const updateCartItemQuantity = useCallback(
//     async (productId, quantity) => {
//       if (!isUserLoggedIn()) {
//         return { success: false, message: "User not logged in" };
//       }

//       try {
//         const user = getUserData();
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_URL}/cart/update-cart-item-quantity`,
//           {
//             userId: user._id,
//             productId: productId,
//             quantity: quantity,
//           },
//           {
//             headers: { "Content-Type": "application/json" },
//           }
//         );

//         // Update cart count after successful update
//         await fetchCartCount();

//         return { success: true, data: response.data };
//       } catch (error) {
//         console.error("Error updating cart item quantity:", error);
//         return { success: false, error };
//       }
//     },
//     [isUserLoggedIn, getUserData, fetchCartCount]
//   );

//   // Method to clear entire cart
//   const clearCart = useCallback(async () => {
//     if (!isUserLoggedIn()) {
//       return { success: false, message: "User not logged in" };
//     }

//     try {
//       const user = getUserData();
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cart/clear-cart`,
//         {
//           userId: user._id,
//         },
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       // Reset cart count after successful clear
//       resetCartCount();

//       return { success: true, data: response.data };
//     } catch (error) {
//       console.error("Error clearing cart:", error);
//       return { success: false, error };
//     }
//   }, [isUserLoggedIn, getUserData, resetCartCount]);

//   useEffect(() => {
//     fetchCartCount();
//   }, [fetchCartCount]);

//   useEffect(() => {
//     const handleStorageChange = () => {
//       fetchCartCount();
//     };

//     window.addEventListener("storage", handleStorageChange);
//     return () => window.removeEventListener("storage", handleStorageChange);
//   }, [fetchCartCount]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       if (abortControllerRef.current) {
//         abortControllerRef.current.abort();
//       }
//     };
//   }, []);

//   const value = {
//     cartCount,
//     cartItems,
//     loading,
//     fetchCartCount,
//     fetchCartData,
//     incrementCartCount,
//     decrementCartCount,
//     resetCartCount,
//     updateCartCount,
//     updateCartOptimistically,
//     removeFromCartOptimistically,
//     addToCartOptimistically,
//     refreshCart,
//     addToCart,
//     removeFromCart,
//     updateCartItemQuantity,
//     clearCart,
//   };

//   return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
// };

// Add these imports at the top
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import GuestSession from "./guestSession";
import toast from "react-hot-toast";

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastFetchTime, setLastFetchTime] = useState(0);

  const CACHE_DURATION = 30000;
  const abortControllerRef = useRef(null);

  const getUserData = useCallback(() => {
    const userData = localStorage.getItem("pm-user-data");
    return userData ? JSON.parse(userData) : null;
  }, []);

  const isUserLoggedIn = useCallback(() => {
    return !!localStorage.getItem("pm-user-data");
  }, []);

  // Get identifier for API calls (userId or guestId)
  const getIdentifier = useCallback(() => {
    if (isUserLoggedIn()) {
      const user = getUserData();
      return { identifier: user?._id, type: 'user' };
    }
    const guestId = GuestSession.getGuestId();
    return { identifier: guestId, type: 'guest' };
  }, [isUserLoggedIn, getUserData]);

  const fetchCartData = useCallback(
    async (forceRefresh = false) => {
      const { identifier, type } = getIdentifier();
      
      if (!identifier) {
        setCartCount(0);
        setCartItems([]);
        return { items: [], count: 0 };
      }

      const now = Date.now();
      const shouldUseCache =
        !forceRefresh && now - lastFetchTime < CACHE_DURATION;

      if (shouldUseCache && cartItems.length > 0) {
        return { items: cartItems, count: cartCount };
      }

      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();

      try {
        setLoading(true);
        
        let url;
        if (type === 'user') {
          url = `${process.env.REACT_APP_API_URL}/cart/get-cart/${identifier}`;
        } else {
          url = `${process.env.REACT_APP_API_URL}/cart/get-guest-cart/${identifier}`;
        }

        const response = await axios.get(url, {
          signal: abortControllerRef.current.signal,
          timeout: 5000,
          headers: GuestSession.getHeaders(),
        });

        const items = response.data.data?.items || [];
        const transformedItems = items.map((item) => ({
          id: item._id,
          name: item.product?.name,
          price: item.product?.price,
          quantity: item.quantity,
          image: item.product?.images?.[0],
          productId: item.product?._id,
          gstPercentage: item.product?.gstPercentage || 0,
          extraTaxPercentage: item.product?.extraTaxPercentage || 0,
          shippingCharge: item.product?.shippingCharge || 0,
          selectedHeight: item.selectedHeight,
          selectedWeight: item.selectedWeight,
        }));

        setCartItems(transformedItems);
        setCartCount(transformedItems.length);
        setLastFetchTime(now);

        return { items: transformedItems, count: transformedItems.length };
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("Request was aborted");
          return { items: cartItems, count: cartCount };
        }

        console.error("Error fetching cart data:", error);
        setCartCount(0);
        setCartItems([]);
        return { items: [], count: 0 };
      } finally {
        setLoading(false);
        abortControllerRef.current = null;
      }
    },
    [getIdentifier, cartItems, cartCount, lastFetchTime]
  );

  const fetchCartCount = useCallback(async () => {
    const { identifier, type } = getIdentifier();
    
    if (!identifier) {
      setCartCount(0);
      return 0;
    }

    try {
      const params = new URLSearchParams();
      if (type === 'user') {
        params.append('userId', identifier);
      } else {
        params.append('guestId', identifier);
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cart/cart-count?${params.toString()}`,
        {
          timeout: 3000,
          headers: GuestSession.getHeaders(),
        }
      );

      const count = response.data.count || 0;
      setCartCount(count);
      setLastFetchTime(Date.now());
      return count;
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartCount(0);
      return 0;
    }
  }, [getIdentifier]);

  const updateCartCount = useCallback((newCount) => {
    setCartCount(newCount);
  }, []);

  const updateCartOptimistically = useCallback((productId, quantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.productId === productId ? { ...item, quantity } : item
      )
    );
  }, []);

  const removeFromCartOptimistically = useCallback((productId) => {
    setCartItems((prevItems) =>
      prevItems.filter((item) => item.productId !== productId)
    );
    setCartCount((prevCount) => Math.max(0, prevCount - 1));
  }, []);

  const addToCartOptimistically = useCallback((newItem) => {
    setCartItems((prevItems) => [...prevItems, newItem]);
    setCartCount((prevCount) => prevCount + 1);
  }, []);

  const incrementCartCount = useCallback(() => {
    setCartCount((prevCount) => prevCount + 1);
  }, []);

  const decrementCartCount = useCallback(() => {
    setCartCount((prevCount) => Math.max(0, prevCount - 1));
  }, []);

  const resetCartCount = useCallback(() => {
    setCartCount(0);
    setCartItems([]);
    setLastFetchTime(0);
  }, []);

  const refreshCart = useCallback(async () => {
    await fetchCartData(true);
  }, [fetchCartData]);

  // Add to cart - works for both logged in and guest users
  const addToCart = useCallback(
    async (productId, quantity = 1, selectedHeight = null, selectedWeight = null) => {
      const { identifier, type } = getIdentifier();
      
      if (!identifier) {
        toast.error("Please login or refresh the page");
        return { success: false, message: "No identifier found" };
      }

      try {
        const body = {
          productId,
          quantity,
        };
        
        if (type === 'user') {
          body.userId = identifier;
        } else {
          body.guestId = identifier;
        }
        
        if (selectedHeight) body.selectedHeight = selectedHeight;
        if (selectedWeight) body.selectedWeight = selectedWeight;

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          body,
          {
            headers: GuestSession.getHeaders(),
          }
        );

        if (response.data.success) {
          await fetchCartCount();
          toast.success("Added to cart!");
          return { success: true, data: response.data.data };
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        toast.error(error.response?.data?.message || "Failed to add to cart");
        return { success: false, error };
      }
    },
    [getIdentifier, fetchCartCount]
  );

  // Remove from cart - works for both logged in and guest users
  const removeFromCart = useCallback(
    async (productId, selectedHeight = null, selectedWeight = null) => {
      const { identifier, type } = getIdentifier();
      
      if (!identifier) {
        toast.error("Please login or refresh the page");
        return { success: false, message: "No identifier found" };
      }

      try {
        const params = new URLSearchParams();
        if (type === 'user') {
          params.append('userId', identifier);
        } else {
          params.append('guestId', identifier);
        }
        params.append('productId', productId);
        if (selectedHeight) params.append('selectedHeight', selectedHeight);
        if (selectedWeight) params.append('selectedWeight', selectedWeight);

        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/cart/remove-cart-item?${params.toString()}`,
          {
            headers: GuestSession.getHeaders(),
          }
        );

        if (response.data.success) {
          await fetchCartCount();
          toast.success("Removed from cart!");
          return { success: true, data: response.data.data };
        }
      } catch (error) {
        console.error("Error removing from cart:", error);
        toast.error(error.response?.data?.message || "Failed to remove from cart");
        return { success: false, error };
      }
    },
    [getIdentifier, fetchCartCount]
  );

  // Update cart item quantity - works for both logged in and guest users
  const updateCartItemQuantity = useCallback(
    async (productId, quantity, selectedHeight = null, selectedWeight = null) => {
      const { identifier, type } = getIdentifier();
      
      if (!identifier) {
        toast.error("Please login or refresh the page");
        return { success: false, message: "No identifier found" };
      }

      try {
        const body = {
          productId,
          quantity,
        };
        
        if (type === 'user') {
          body.userId = identifier;
        } else {
          body.guestId = identifier;
        }
        
        if (selectedHeight) body.selectedHeight = selectedHeight;
        if (selectedWeight) body.selectedWeight = selectedWeight;

        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/cart/update-cart-item`,
          body,
          {
            headers: GuestSession.getHeaders(),
          }
        );

        if (response.data.success) {
          await fetchCartCount();
          return { success: true, data: response.data.data };
        }
      } catch (error) {
        console.error("Error updating cart item quantity:", error);
        toast.error(error.response?.data?.message || "Failed to update cart");
        return { success: false, error };
      }
    },
    [getIdentifier, fetchCartCount]
  );

  // Clear cart - works for both logged in and guest users
  const clearCart = useCallback(async () => {
    const { identifier, type } = getIdentifier();
    
    if (!identifier) {
      toast.error("Please login or refresh the page");
      return { success: false, message: "No identifier found" };
    }

    try {
      const params = new URLSearchParams();
      if (type === 'user') {
        params.append('userId', identifier);
      } else {
        params.append('guestId', identifier);
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/cart/clear-cart?${params.toString()}`,
        {
          headers: GuestSession.getHeaders(),
        }
      );

      if (response.data.success) {
        resetCartCount();
        toast.success("Cart cleared!");
        return { success: true, data: response.data };
      }
    } catch (error) {
      console.error("Error clearing cart:", error);
      toast.error(error.response?.data?.message || "Failed to clear cart");
      return { success: false, error };
    }
  }, [getIdentifier, resetCartCount]);

  // Guest specific methods
  const addToCartAsGuest = useCallback(
    async (productId, quantity = 1, selectedHeight = null, selectedWeight = null) => {
      const guestId = GuestSession.getGuestId();
      if (!guestId) {
        toast.error("Unable to identify guest session");
        return { success: false, message: "Guest ID not found" };
      }

      try {
        const body = {
          guestId,
          productId,
          quantity,
        };
        if (selectedHeight) body.selectedHeight = selectedHeight;
        if (selectedWeight) body.selectedWeight = selectedWeight;

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          body,
          {
            headers: GuestSession.getHeaders(),
          }
        );

        if (response.data.success) {
          await fetchCartCount();
          toast.success("Added to cart!");
          return { success: true, data: response.data.data };
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        toast.error(error.response?.data?.message || "Failed to add to cart");
        return { success: false, error };
      }
    },
    [fetchCartCount]
  );

  const getGuestCart = useCallback(async (guestId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cart/get-guest-cart/${guestId}`,
        {
          headers: GuestSession.getHeaders(),
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching guest cart:", error);
      return null;
    }
  }, []);

  const mergeCartsAfterLogin = useCallback(async (userId, guestId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/cart/merge-carts`,
        { userId, guestId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.success) {
        await fetchCartCount();
        GuestSession.clearGuestId();
        toast.success("Cart merged successfully!");
        return { success: true, data: response.data.data };
      }
    } catch (error) {
      console.error("Error merging carts:", error);
      toast.error("Failed to merge cart");
      return { success: false, error: error.response?.data?.message };
    }
  }, [fetchCartCount]);

  // Wishlist guest methods
  const addToWishlistAsGuest = useCallback(async (productId) => {
    try {
      const body = GuestSession.getRequestBody({ productId });
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`,
        body,
        {
          headers: GuestSession.getHeaders(),
        }
      );

      if (response.data.success) {
        toast.success("Added to wishlist!");
        return { success: true, data: response.data.data };
      }
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      toast.error(error.response?.data?.message || "Failed to add to wishlist");
      return { success: false, error: error.response?.data?.message };
    }
  }, []);

  const removeFromWishlistAsGuest = useCallback(async (productId) => {
    try {
      const body = GuestSession.getRequestBody({ productId });
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`,
        body,
        {
          headers: GuestSession.getHeaders(),
        }
      );

      if (response.data.success) {
        toast.success("Removed from wishlist!");
        return { success: true, data: response.data.data };
      }
    } catch (error) {
      console.error("Error removing from wishlist:", error);
      toast.error(error.response?.data?.message || "Failed to remove from wishlist");
      return { success: false, error: error.response?.data?.message };
    }
  }, []);

  const getGuestWishlist = useCallback(async (guestId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/wishlist/guest-wishlist/${guestId}`,
        {
          headers: GuestSession.getHeaders(),
        }
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching guest wishlist:", error);
      return null;
    }
  }, []);

  const mergeWishlistsAfterLogin = useCallback(async (userId, guestId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/wishlist/merge-wishlists`,
        { userId, guestId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("Wishlist merged successfully!");
        return { success: true, data: response.data.data };
      }
    } catch (error) {
      console.error("Error merging wishlists:", error);
      toast.error("Failed to merge wishlist");
      return { success: false, error: error.response?.data?.message };
    }
  }, []);

  // Load cart on mount and when login status changes
  useEffect(() => {
    fetchCartCount();
  }, [fetchCartCount]);

  // Listen for login/logout events
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'pm-user-data' || e.key === 'guest_id') {
        fetchCartCount();
      }
    };

    // Listen for guest cart updates
    const handleGuestCartUpdate = () => {
      fetchCartCount();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('guest-cart-updated', handleGuestCartUpdate);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('guest-cart-updated', handleGuestCartUpdate);
    };
  }, [fetchCartCount]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const value = {
    // State
    cartCount,
    cartItems,
    loading,
    
    // Core methods
    fetchCartCount,
    fetchCartData,
    refreshCart,
    
    // Cart operations (works for both logged in and guest)
    addToCart,
    removeFromCart,
    updateCartItemQuantity,
    clearCart,
    
    // Optimistic updates
    incrementCartCount,
    decrementCartCount,
    resetCartCount,
    updateCartCount,
    updateCartOptimistically,
    removeFromCartOptimistically,
    addToCartOptimistically,
    
    // Guest specific methods
    addToCartAsGuest,
    getGuestCart,
    mergeCartsAfterLogin,
    
    // Wishlist guest methods
    addToWishlistAsGuest,
    removeFromWishlistAsGuest,
    getGuestWishlist,
    mergeWishlistsAfterLogin,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};